import React, { FC, useRef } from 'react';
import { Drawer } from 'antd';
import { Form, Formik } from 'formik';
import InputField from '../InputField';
import ButtonComponent from '../ButtonComponent';
import { UpdatePasswordValidationSchema } from '../../../views/Institute/instituteFormValidation';

interface PasswordUpdateDrawerProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: { password: string; confirmPassword: string }) => void;
}

const PasswordUpdateDrawer: FC<PasswordUpdateDrawerProps> = ({ open, onClose, onSubmit }) => {
  const formRef = useRef<any>(null);

  const handleSubmit = (values: { password: string; confirmPassword: string }) => {
    onSubmit(values);
  };

  return (
    <Drawer
      closable
      destroyOnClose
      title={<p>Update Password</p>}
      placement='right'
      open={open}
      onClose={onClose}
    >
      <Formik
        initialValues={{ password: '', confirmPassword: '' }}
        onSubmit={handleSubmit}
        enableReinitialize
        innerRef={formRef}
        validationSchema={UpdatePasswordValidationSchema}
      >
        {({ handleSubmit }) => (
          <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>New Password</div>
              <InputField
                type='password'
                name='password'
                placeholder='Enter password'
              />
            </div>
            <div className='institute-student-form__input'>
              <div className='institute-student-form__label'>Confirm Password</div>
              <InputField
                type='password'
                name='confirmPassword'
                placeholder='Confirm password'
              />
            </div>
            <div className='institute-student-form__input'>
              <ButtonComponent
                className='header-add-btn'
                buttonContent='Update'
                type='primary'
                onClick={handleSubmit}
              />
            </div>
          </Form>
        )}
      </Formik>
    </Drawer>
  );
};

export default PasswordUpdateDrawer;
